module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-9.svg?289ef252203103235a6339cb31268f6f";